export default __webpack_public_path__ + "static/media/Sentier-d’interprétation.77c0a724.svg";